export const infoData = [
  //{id:"", value: "Summary", name: "summary" },
  { id: "ping4", value: "Ping4", name: "Ping4" },
  { id: "ping6", value: "Ping6", name: "Ping6" },
  { id: "traceroute4", value: "TraceRoute4", name: "TraceRoute4" },
  { id: "traceroute6", value: "TraceRoute6", name: "TraceRoute6" },
  { id: "netscan", value: "NetScan", name: "NetScan" },
  { id: "uptime", value: "Uptime", name: "Uptime" },
  { id: "wiremap", value: "WireMap", name: "Wiremap" },
  { id: "poeload", value: "PoeLoad", name: "PoE Load" },
  { id: "maxthroughput", value: "Maxthroughput", name: "Maxthroughput" },
  { id: "webdata", value: "WebData", name: "Web Data" },
  { id: "cabledata", value: "CableData", name: "Cable Data" },
  { id: "customdata", value: "CustomData", name: "Custom Data" },
  { id: "voipdata", value: "VoIPData", name: "VoIP Data" },
  { id: "videodata", value: "VideoData", name: "Video Data" },
  { id: "cctvdata", value: "CCTVData", name: "CCTV Data" },
  { id: "fiberlengthloss", value: "FiberLengthLoss", name: "Fiber Length & Loss" },
  { id: "qualification", value: "Qualification", name: "Qualification" },
  { id: "stats", value: "Stats", name: "Stats" },
  { id: "qualification_il", value: "Insertion Loss", name: "Insertion Loss" },
  { id: "qualification_rl", value: "Return Loss", name: "Return Loss" },
  { id: "qualification_next", value: "NEXT", name: "NEXT" },
];



// WEBPACK FOOTER //
// ./src/components/common/results/infoenum.js